import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06829763"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "app__header__title" }
const _hoisted_3 = {
  key: 0,
  class: "app__title"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons gray__base__color room__icon" }, "hotel")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "room__text gray__base__color"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons gray__base__color room__icon" }, "people")
], -1))
const _hoisted_9 = {
  key: 0,
  class: "room__text gray__base__color"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons gray__base__color room__icon" }, "face")
], -1))
const _hoisted_11 = {
  key: 0,
  class: "room__text gray__base__color"
}
const _hoisted_12 = { class: "room__info__title primary__dark__color" }
const _hoisted_13 = { class: "justify gray__base__color" }
const _hoisted_14 = { class: "room__info__title primary__dark__color" }
const _hoisted_15 = { class: "gray__base__color" }
const _hoisted_16 = { class: "capitalize pr-05" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "$", -1))
const _hoisted_18 = { class: "pr-05" }
const _hoisted_19 = { class: "pr-05" }
const _hoisted_20 = { class: "lowercase taxes_text" }
const _hoisted_21 = { class: "room__info__title primary__dark__color" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commoditties__align" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons commoditties__icon" }, "add_box")
], -1))
const _hoisted_23 = { class: "commoditties__align" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commoditties__align" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons commoditties__icon" }, "wifi")
], -1))
const _hoisted_25 = { class: "commoditties__align" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commoditties__align" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons commoditties__icon" }, "waves")
], -1))
const _hoisted_27 = { class: "commoditties__align" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commoditties__align" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons commoditties__icon" }, "restaurant")
], -1))
const _hoisted_29 = { class: "commoditties__align" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commoditties__align" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons commoditties__icon" }, "fitness_center")
], -1))
const _hoisted_31 = { class: "commoditties__align" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commoditties__align" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons commoditties__icon" }, "local_parking")
], -1))
const _hoisted_33 = { class: "commoditties__align" }
const _hoisted_34 = { class: "room__info__title mb primary__dark__color" }
const _hoisted_35 = { class: "room__info__title primary__dark__color" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "calendar" }, null, -1))
const _hoisted_37 = { class: "date__selector__textHeight ptop date__selector__textCheck" }
const _hoisted_38 = { class: "date__selector__textHeight" }
const _hoisted_39 = { class: "date__selector__textHeight date__selector__textCheck" }
const _hoisted_40 = { class: "date__selector__textHeight pb" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filter_sidebar = _resolveComponent("filter-sidebar")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Markdown = _resolveComponent("Markdown")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CoronaRoomFilter = _resolveComponent("CoronaRoomFilter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toogleFilterDrawer && _ctx.toogleFilterDrawer(...args)))
    }, [
      _createVNode(_component_filter_sidebar)
    ]),
    _createVNode(_component_el_row, {
      gutter: 20,
      class: "container__position",
      id: "roomPicture"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("hotels.hotelBooking")), 1),
            (_ctx.room && _ctx.room.roomName)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.room.roomName), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24
        }, {
          default: _withCtx(() => [
            (_ctx.room && _ctx.room.pictures)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_el_carousel, {
                    "indicator-position": "none",
                    class: "room__pictures__carousel"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.room.pictures, (picture, index) => {
                        return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: picture,
                              style: {"width":"100%"}
                            }, null, 8, _hoisted_5)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      guter: 24,
      class: "center pt__1",
      id: "people"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _hoisted_6,
            (_ctx.room && _ctx.room.roomType)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.room.roomType), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _hoisted_8,
            (_ctx.room && _ctx.room.roomCapacityAdults)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, " x" + _toDisplayString(_ctx.room.roomCapacityAdults), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _hoisted_10,
            (_ctx.room && _ctx.room.roomCapacitychildren)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, " x" + _toDisplayString(_ctx.room.roomCapacitychildren), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      gutter: 20,
      id: "generalInfo"
    }, {
      default: _withCtx(() => [
        (_ctx.room && _ctx.room.description)
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              xs: 24,
              sm: 24,
              md: 24,
              lg: 24,
              xl: 24,
              id: "description"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t("hotels.room.roomDescription")), 1),
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.room.description), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.room && _ctx.room.price)
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 1,
              xs: 24,
              sm: 24,
              md: 24,
              lg: 24,
              xl: 24,
              id: "price"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.$t("hotels.room.price")), 1),
                _createElementVNode("p", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("hotels.from")), 1),
                  _hoisted_17,
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.room.amount), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.room.currency), 1),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("hotels.room.perNight")), 1),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("hotels.room.taxesNotIncluded")), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.room && _ctx.room.commodities)
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 2,
              xs: 24,
              sm: 24,
              md: 24,
              lg: 24,
              xl: 24,
              id: "commodities"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_21, _toDisplayString(_ctx.$t("hotels.room.roomCommodities")), 1),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_row, { gutter: 20 }, {
                    default: _withCtx(() => [
                      (_ctx.room.commodities.allInclusive)
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 0,
                            class: "pt__1 gray__base__color",
                            xs: 24,
                            sm: 12,
                            md: 6,
                            lg: 6,
                            xl: 6
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _hoisted_22,
                                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("hotels.allInclusive")), 1)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.room.commodities.freeWifi)
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 1,
                            class: "pt__1 gray__base__color",
                            xs: 24,
                            sm: 12,
                            md: 6,
                            lg: 6,
                            xl: 6
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _hoisted_24,
                                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("hotels.freeWifi")), 1)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.room.commodities.airConditioning)
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 2,
                            class: "pt__1 gray__base__color",
                            xs: 24,
                            sm: 12,
                            md: 6,
                            lg: 6,
                            xl: 6
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _hoisted_26,
                                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("hotels.airConditioning")), 1)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.room.commodities.complimentaryBreakfast)
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 3,
                            class: "pt__1 gray__base__color",
                            xs: 24,
                            sm: 12,
                            md: 6,
                            lg: 6,
                            xl: 6
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _hoisted_28,
                                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("hotels.complimentaryBreakfast")), 1)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.room.commodities.fitnessCenter)
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 4,
                            class: "pt__1 gray__base__color",
                            xs: 24,
                            sm: 12,
                            md: 6,
                            lg: 6,
                            xl: 6
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _hoisted_30,
                                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("hotels.fitnessCenter")), 1)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.room.commodities.parking)
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 5,
                            class: "pt__1 gray__base__color",
                            xs: 24,
                            sm: 12,
                            md: 6,
                            lg: 6,
                            xl: 6
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _hoisted_32,
                                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("hotels.parking")), 1)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.room && _ctx.room.additionalInfo)
      ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          gutter: 20,
          id: "additionalInfo",
          class: "pt__1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 24,
              lg: 24,
              xl: 24
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_34, _toDisplayString(_ctx.$t("hotels.room.additionalInfo")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 24,
              lg: 24,
              xl: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Markdown, {
                  source: _ctx.room.additionalInfo,
                  class: "additionalInfo gray__base__color"
                }, null, 8, ["source"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("h3", _hoisted_35, _toDisplayString(_ctx.$t("hotels.room.datesAvailable")), 1),
    _createVNode(_component_el_alert, {
      title: _ctx.$t('hotels.infoMessage.title'),
      type: "info",
      "show-icon": "",
      effect: "dark"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("hotels.infoMessage.infoMessageCalendar")), 1)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_el_row, { class: "pb__1 mt-2" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 15,
          lg: 12,
          xl: 12
        }, {
          default: _withCtx(() => [
            _hoisted_36
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      gutter: 20,
      class: "pt__1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24,
          class: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "secondary__color__button",
              onClick: _ctx.toggleRoomFilter
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("hotels.room.makeReservation")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_CoronaRoomFilter, { hotelDetails: _ctx.hotelDetails }, null, 8, ["hotelDetails"]),
    _createElementVNode("div", {
      class: "secondary__dark__color__bg date__selector__container",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleRoomFilter && _ctx.toggleRoomFilter(...args)))
    }, [
      _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.$t("hotels.checkIn")), 1),
      _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.actualDate), 1),
      _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$t("hotels.checkOut")), 1),
      _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.actualDate), 1)
    ])
  ]))
}